<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-active">新建预约</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <h4 id="title">预约信息填写</h4>
          <div id="infos">
            <p>疫苗种类</p>
            <b-form-select
                v-model="appData.vtid" :options="vtidOpt">
            </b-form-select>
            <p>医院</p>
            <b-input v-model="appData.hospital"></b-input>
            <p>预约日期</p>
            <b-form-datepicker
                id="datepick"
                v-model="appData.date"></b-form-datepicker>
            <div></div><div></div>
            <p>入场时间</p>
            <b-time v-model="startTime"></b-time>
            <p>离场时间</p>
            <b-time v-model="endTime"></b-time>
          </div>
          <b-button pill id="change" variant="info" v-on:click="onSubmit">新建预约</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "AppointmentNew",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      appData: {
        vtid: -1,
        hospital: "",
        date: "",
        time: "",
      },
      vtidOpt: [],
      startTime: "",
      endTime: ""
    }
  },
  methods: {
    onSubmit() {
      if (this.vtidOpt === -1
          || this.startTime.length === 0
          || this.endTime.length === 0
          || this.appData.hospital.length === 0) {
        alert("信息未填写完整");
      } else {
        this.appData.time = this.startTime + " - " + this.endTime;
        this.axios.post(common.apiBase+common.apiService.addAppointment, {
          token: localStorage.getItem('loginToken'),
          data: this.appData
        }).then((res)=>{
          console.log(res.data);
          alert("预约成功");
          this.$router.push("/");
        }).catch((err)=>{
          console.log(err);
        });
      }
    }
  },
  mounted() {
    common.assureLogin(this);
    this.appData.hospital = this.$route.params.hospital;
    this.appData.vtid = this.$route.params.vtid;
    this.axios.post(common.apiBase + common.apiService.getAllVaccineType, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      for(let i of res.data.data) {
        this.vtidOpt.push({
          value:i['vtid'],
          text:i['name']
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
</script>

<style>

body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>
#content {
  padding-left: 10%;
  padding-top: 3vh;
}

#title {
  font-weight: bold;
}

#infos {
  margin-top: 40px;
  display: grid;
  grid-template-columns: 100px 4fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 2fr 2fr;
  width: 90%;
}

#datepick {
  height: 100%;
}

#infos p {
  color: grey;
  line-height: 60px;
}

#change, #logout{
  margin-left: 50%;
  transform: translateX(-50%);
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
</style>